$('img').on('error', function() {
    $(this).attr('src', '/img/food-placeholder.png');
});